<button (click)="rightClick()" class="button"></button>
